import React from 'react';

import type { WidgetInstanceProps } from '../types/Widget';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export interface StarsWidgetContextValue<C = any> {
  widgetId: WidgetInstanceProps['id'];
  widgetConfig?: C;
}

const StarsWidgetContext = React.createContext<StarsWidgetContextValue | undefined>(undefined);

export default StarsWidgetContext;
